import {entityType} from "./module";
import {createGetAllMethod} from "reactcoregk/store/actions";
import {getDefaultApiHandler} from "../../helpers/utils";

export const getAllRoles = (params) => createGetAllMethod(entityType, params, getDefaultApiHandler())
